import type { InvoiceResponse } from '../../api/types';
import {
  getMissingInvoicePdfs,
  type InvoicePdfVariant,
  type MissingInvoicePdfs,
} from '../../api/endpoints/invoicePdfs';
import { invoicePdfQueue } from './invoicePdfUpload';
export async function catchUpInvoicePdfs(
  list: (afterId: number) => Promise<MissingInvoicePdfs> = getMissingInvoicePdfs,
  generate: (invoice: InvoiceResponse, variant: InvoicePdfVariant) => Promise<boolean> = (
    invoice,
    variant,
  ) => invoicePdfQueue.ensure(invoice, variant),
  active: () => boolean = () => true,
) {
  let afterId = 0;
  do {
    if (!active()) return;
    const page = await list(afterId);
    if (!active()) return;
    for (const item of page.items) {
      for (const copy of item.copies) {
        if (!active()) return;
        await generate(item.invoice, copy);
      }
    }
    if (page.nextAfterId == null) return;
    if (page.nextAfterId <= afterId) throw new Error('Invalid PDF catch-up cursor');
    afterId = page.nextAfterId;
  } while (active());
}
